import React from "react";

const LoadingSpinner = ({ label = "Loading…" }) => (
  <div style={{
    display: "flex", justifyContent: "center", alignItems: "center",
    height: "100vh", fontSize: "14px", color: "rgba(255,255,255,0.4)",
    background: "#0F1115", letterSpacing: "0.1em",
    fontFamily: "Inter, sans-serif",
  }}>
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
      <div style={{
        width: "32px", height: "32px",
        border: "2px solid rgba(198,40,40,0.2)",
        borderTop: "2px solid #C62828",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }} />
      <span>{label}</span>
    </div>
  </div>
);

export default LoadingSpinner;
